module.exports = __webpack_public_path__ + "static/img/brief_4.e352ccf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/brief_4.jpg
// module id = Yt9F
// module chunks = 1